import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Card, CommitteeHeader } from "@components/common/card";
import type { VoteListEntry } from "@lib/api/vote/types";
import { routes } from "@lib/navigation";
import VoteResult from "./vote-result";
interface Props {
  vote: VoteListEntry;
}
export default function Vote(t0) {
  const $ = _c(21);
  const {
    vote
  } = t0;
  let t1;
  if ($[0] !== vote.documentId || $[1] !== vote.proposition) {
    t1 = routes.vote(vote.documentId, vote.proposition);
    $[0] = vote.documentId;
    $[1] = vote.proposition;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== vote.committee) {
    t2 = <CommitteeHeader committee={vote.committee} />;
    $[3] = vote.committee;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== vote.title) {
    t3 = <p className="text-sm text-slate-600 dark:text-slate-400">{vote.title}</p>;
    $[5] = vote.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== vote.subtitle) {
    t4 = <p>{vote.subtitle}</p>;
    $[7] = vote.subtitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="p-4">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== vote.results) {
    t6 = <VoteResult votes={vote.results} />;
    $[12] = vote.results;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <Card className="p-0">{t2}{t5}{t6}</Card>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = <Link href={t1}>{t7}</Link>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}